import * as yup from 'yup';

const RequestPasswordSchema = yup.object().shape({
    email: yup.string()
        .email('Please Enter a valid Email Address')
        .required('Required')
});

export default RequestPasswordSchema;